<template>
	<MyFormRow
		:label="label"
		:validate="validate"
		:width="labelWidth"
		:labelAlign="labelAlign"
		:color="color"
		:labelPosition="labelPosition"
	>
		<v-text-field
			:value="value"
			:rules="rules"
			:disabled="disabled"
			:readonly="readonly"
			:append-icon="isPassword ? (show ? 'mdi-eye' : 'mdi-eye-off') : null"
			outlined
			dense
			single-line
			:class="{ 'password-input': isPassword }"
			:type="isPassword ? (show ? 'text' : type) : type"
			@click:append="isPassword ? (show = !show) : null"
			@input="onInput"
			@keydown.enter="onEnter"
			:placeholder="placeholder"
			:error="error"
			:error-messages="!errorMessages ? [] : errorMessages"
			:append-outer-icon="appendOuterIcon ? appendOuterIcon : null"
			:inputmode="inputmode"
			:enterkeyhint="enterkeyhint"
			:autofocus="autofocus"
			:suffix="suffix"
			ref="ref"
			:hint="hint"
			:maxlength="maxlength"
			:autocomplete="autocomplete"
			persistent-hint
			:clearable="clearable"
			@blur="onBlur"
		></v-text-field>
	</MyFormRow>
</template>
<script>
import MyFormRow from '@/components/FormRow.vue'

export default {
	name: 'MyTextField',
	components: { MyFormRow },
	// components: { COMPONENT_NAME },
	props: {
		value: {
			required: false,
			type: String | Number,
		},
		rules: {
			required: false,
			type: Array,
			default: () => [],
		},
		type: {
			required: false,
			type: String,
			default: 'text',
		},
		disabled: {
			required: false,
			type: Boolean,
		},
		readonly: {
			required: false,
			type: Boolean,
		},
		maxlength: {
			required: false,
			type: [Number, null],
			default: null, // 默认不限制长度
		},
		// 以下皆為 FormRow 參數
		label: {
			required: false,
			type: String,
			default: '名稱',
		},
		labelWidth: {
			required: false,
			type: Number | String,
			default: 'auto',
		},
		labelAlign: {
			required: false,
			type: String,
			default: 'left',
		},
		labelPosition: {
			required: false,
			type: String,
			default: 'left',
		},
		color: {
			required: false,
			type: String,
			default: 'dark',
		},
		placeholder: {
			required: false,
			type: String,
		},
		error: {
			required: false,
			type: Boolean,
			default: false,
		},
		errorMessages: {
			required: false,
		},
		appendOuterIcon: {
			required: false,
		},
		inputmode: {
			required: false,
		},
		enterkeyhint: {
			required: false,
			type: String,
			default: 'none',
		},
		autofocus: { required: false, type: Boolean, default: false },
		search: {
			required: false,
			type: Boolean,
		},
		suffix: {
			required: false,
			type: String,
			default: '',
		},
		hint: {
			required: false,
			type: String,
		},
		autocomplete: {
			required: false,
			type: String,
		},
		clearable: {
			type: Boolean,
			default: false,
		},
		required: {
			type: Boolean,
			default: undefined, // 預設 undefined 供後續 validate 判斷
		},
	},
	model: {
		prop: 'value',
		event: 'updateValue',
	},
	data() {
		return {
			show: false,
		}
	},
	computed: {
		validate() {
			// 有明確指定 required → 以 required 為準(針對選填項目但有輸入時還是需檢查格式的部分，不須呈現*字號)
			if (this.required !== undefined) {
				return this.required
			}
			// 沒指定 → 維持舊行為
			return this.rules.length > 0
		},
		isPassword() {
			return this.type === 'password'
		},
	},

	// watch: {},
	// created() {},
	// mounted() {},
	// beforeDestroy() {},
	methods: {
		onInput(val) {
			this.$emit('updateValue', val)
			this.$emit('onInput', val)
		},
		onEnter() {
			const { value } = this
			this.$emit('updateValue', value)
			this.$emit('onEnter', value)
		},
		focus() {
			this.$refs.ref?.focus()
		},
		onBlur(event) {
			this.$emit('blur', event)
		},
	},
}
</script>
<style lang="scss" scoped>
::v-deep {
	.v-text-field__slot {
		input {
			font-size: 1rem;
		}
	}
}
</style>
